import moment from 'moment';
import React from 'react';
import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import TimeTakesPlace from '../components/time-takes-place/index';
// import { dataDummy } from './data';

const ACTIONS = {
    GET_INFO_TEAM_SCHEDULE_SUCCESS: 'GET_INFO_TEAM_SCHEDULE_SUCCESS',
    GET_INFO_TEAM_SCHEDULE_ERROR: 'GET_INFO_TEAM_SCHEDULE_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});


const getTeamSchedule = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // team_id
    // year_id
    // month_id
    // scheduled_game_start_datetime
    let url = `${host.serverTest}api/teams/${data.team_id}/years/${data.year_id}/months/${data.month_id}/schedules?sort=scheduled_game_start_datetime&order=ASC`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                // console.log(data);

                dispatch(updateStatus(ACTIONS.GET_INFO_TEAM_SCHEDULE_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_INFO_TEAM_SCHEDULE_ERROR, err));
            });
    };
};

const convertDataSchedule = (list) => {
    if (list) {
        const arr = list.map((value) => {
            let status = '';
            if(value.game_status === null) {
                status = <TimeTakesPlace
                leftText = {value.home_team ? value.home_team.team_name_s: ''}
                centerText = {moment(value.scheduled_game_start_hms, 'HH:mm:ss').format('HH:mm')}
                rightText = {value.away_team ? value.away_team.team_name_s : '' }
            />
            }
            if(value.game_status === '試合中止') {
                status = '試合中止';
            }

            if(value.game_status === '試合終了') {
                status = <TimeTakesPlace
                leftText = {value.home_team ? value.home_team.team_name_s: ''}
                centerText = {`${value.result.home_team_score} - ${value.result.away_team_score}`}
                rightText = {value.away_team ? value.away_team.team_name_s : '' }
            />
            }
            return {
                complete: value.game_status === '試合終了',
                id: value.id,
                game_date: moment(value.game_date, 'YYYY/MM/DD').format('MM-DD-YYYY'),
                item: [
                    { text: value.game_display_date},
                    {
                        text: status,
                        type: 'html'
                    },
                    { text: value.stadium_name },
                    { text: value.result.w_pitcher.player_name },
                    { text: value.result.sv_pitcher.player_name },
                    { text: value.result.l_pitcher.player_name },
                    { text: value.result.attendance }
                ]
            }
        });
        return arr;
    }
}

export {
    ACTIONS, getTeamSchedule, convertDataSchedule
};